import { render } from "./JournalList.vue?vue&type=template&id=4d48d008&scoped=true"
import script from "./JournalList.vue?vue&type=script&lang=js"
export * from "./JournalList.vue?vue&type=script&lang=js"

import "./JournalList.vue?vue&type=style&index=0&id=4d48d008&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d48d008"]])

export default __exports__